import React, { useEffect } from 'react';
import PageSEO from '../components/SEO/PageSEO';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import StatsBanner from '../components/StatsBanner';
import FAQSection from '../components/FAQ/FAQSection';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Comprendre les SES",
    "url": "https://cours-ses.fr",
    "logo": "https://cours-ses.fr/Logo SES.png",
    "description": "Plateforme éducative spécialisée dans les Sciences Économiques et Sociales, proposant des cours particuliers, des flashcards et des ressources gratuites pour les élèves de lycée.",
    "sameAs": [
      "https://www.youtube.com/@comprendrelesses",
      "https://www.instagram.com/comprendre_les_ses",
      "https://www.tiktok.com/@comprendre_les_ses"
    ],
    "founders": [
      {
        "@type": "Person",
        "name": "Brandon MAESTU"
      },
      {
        "@type": "Person",
        "name": "Marion MOREAU"
      }
    ],
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Apt",
      "addressRegion": "Provence-Alpes-Côte d'Azur",
      "postalCode": "84400",
      "addressCountry": "FR"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "email": "comprendrelessespro@gmail.com",
      "availableLanguage": ["French"]
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <PageSEO
        title="Comprendre les SES | Cours, Flashcards et Ressources de Révision"
        description="Réussissez votre bac SES avec nos cours particuliers, flashcards et ressources gratuites. Méthodes efficaces pour réviser les Sciences Économiques et Sociales."
        path="/"
        schema={schema}
      />
      <Navbar />
      <main className="pt-16">
        <Hero />
        <div className="border-b border-[#9a6ebd]/10" />
        <Services />
        <div className="border-b border-[#9a6ebd]/10" />
        <About />
        <div className="border-b border-[#9a6ebd]/10" />
        <StatsBanner />
        <div className="border-b border-[#9a6ebd]/10" />
        <FAQSection />
        <div className="border-b border-[#9a6ebd]/10" />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;